import Swiper, { Autoplay } from "swiper";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

const scrollingTextTop = document.querySelectorAll(".scrolling-text .swiper-top");
const scrollingTextbottom = document.querySelectorAll(".scrolling-text .swiper-bottom");

scrollingTextTop.forEach((slider) => {

  const scrollingTextTopOptions = {
    modules: [Autoplay],
    spaceBetween: 20,
    slidesPerView: "auto",
    loop: true,
    loopedSlides: 6,
    freeMode: true,
    speed: 50000,
    allowTouchMove: false,
    centeredSlides: true,
  };

  if (!isAnimationStopped()) {
    scrollingTextTopOptions.autoplay = {
      delay: 1,
      disableOnInteraction: false,
    };
  }

  new Swiper(slider, scrollingTextTopOptions);
});

scrollingTextbottom.forEach((slider) => {

  const scrollingTextbottomOptions = {
    modules: [Autoplay],
    spaceBetween: 20,
    slidesPerView: "auto",
    loop: true,
    loopedSlides: 6,
    freeMode: true,
    speed: 50000,
    allowTouchMove: false,
    centeredSlides: true,
  };

  if (!isAnimationStopped()) {
    scrollingTextbottomOptions.autoplay = {
      delay: 1,
      disableOnInteraction: false,
      reverseDirection: true,
    };
  }

  new Swiper(slider, scrollingTextbottomOptions);
});
